import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { alertModal } from '../../actions/general';

class AlertModal extends React.Component {
  onBtnClick = type => {
    switch (type) {
      case 'confirm':
        const { onConfirm } = this.props;
        if (onConfirm) onConfirm();
        break;
      case 'cancel':
        const { onCancel } = this.props;
        if (onCancel) onCancel();
        break;
      default:
        break;
    }

    this.props.alertModal(false);
  };

  closeModal = () => {
    this.props.alertModal(false);
  };

  render() {
    const { show, alertText } = this.props;
    const bodyText = alertText || '¿Seguro desea realizar esta acción?';
    return (
      <Modal toggle={this.closeModal} isOpen={show} data-background="light">
        <ModalHeader>Alerta</ModalHeader>
        <ModalBody>{bodyText}</ModalBody>
        <ModalFooter>
          <button
            className="btn btn-danger"
            onClick={() => this.onBtnClick('confirm')}
          >
            Confirmar
          </button>
          <button
            className="btn btn-default btn-outline"
            onClick={() => this.onBtnClick('cancel')}
          >
            Cancelar
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { show, onConfirm, onCancel, alertText } = state.ui;
  return {
    show,
    onConfirm,
    onCancel,
    alertText,
  };
};

export default connect(
  mapStateToProps,
  { alertModal }
)(AlertModal);



// WEBPACK FOOTER //
// ./src/components/UI/AlertModal.js